var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedbackChatIcon = function SvgFeedbackChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#423DCF",
    clipPath: "url(#FeedbackChatIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.55 24.593c0 .051.009.101.009.153 0 15.832-13.8 28.711-30.762 28.711H18.07C21.722 63.122 31.585 70 43.203 70H67.95a2.051 2.051 0 0 0 1.394-3.555l-5.61-5.203C67.792 56.81 70 51.12 70 45.254c0-8.498-4.933-16.204-12.45-20.661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.657 45.8a2.05 2.05 0 0 0 1.394 3.556h24.746c14.7 0 26.66-11.04 26.66-24.61S41.497 0 26.797 0 0 11.176 0 24.746c0 5.866 2.209 11.42 6.267 15.851zm13.835-33.359h24.61a2.05 2.05 0 0 1 2.05 2.051 2.05 2.05 0 0 1-2.05 2.051h-24.61a2.05 2.05 0 0 1-2.05-2.05 2.05 2.05 0 0 1 2.05-2.052m0 8.204h24.61a2.05 2.05 0 0 1 2.05 2.05 2.05 2.05 0 0 1-2.05 2.051h-24.61a2.05 2.05 0 0 1-2.05-2.05 2.05 2.05 0 0 1 2.05-2.052m0 8.203h24.61a2.05 2.05 0 0 1 2.05 2.05 2.05 2.05 0 0 1-2.05 2.051h-24.61a2.05 2.05 0 0 1-2.05-2.05 2.05 2.05 0 0 1 2.05-2.051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FeedbackChatIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgFeedbackChatIcon;